define([
	"dojo/_base/declare",
	"csi/heading/Ref"
], function(declare, Ref) {

	return declare(Ref, {
		bCopy: true,

		/**
		 * @override
		 * Only allow copying if the size range is specified and for Styles; we don't want it to
		 * be too easy to wipe out all sizes on a Style
		 */
		canCopy: function(ctxCopy, h) {
			const sizeRange = ctxCopy.getChildNode("ActualSizeRange");
			if (!sizeRange || !sizeRange.OKforStyle) {
				return false;
			}

			return this.inherited(arguments);
		}
	});
});